import { render, staticRenderFns } from "./LgFinderPageTipoProblema.vue?vue&type=template&id=ed457daa"
import script from "./LgFinderPageTipoProblema.vue?vue&type=script&lang=js"
export * from "./LgFinderPageTipoProblema.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports